export function extractTeamsFromSubeventName(subeventName: string) {
  const teamSeparators = [' v ', ' at '] as const;

  for (const separator of teamSeparators) {
    const teams = subeventName.split(separator);
    if (teams.length === 2) {
      const [first, second] = teams.map(team => team.trim());
      return separator === ' v '
        ? { away: second, first, home: first, second, separator, success: true }
        : { away: first, first, home: second, second, separator, success: true };
    }
  }
  return {
    away: '',
    first: '',
    home: '',
    second: '',
    separator: '',
    success: false,
  };
}
